import {
    GET_CONFIG_FORM44,
    GET_DATOS_GESTION_IMPLICADO_VISA,
    GET_COMBO_INSTANCIAS_PROVISIONES_VISA,
    GET_PROVISIONES_VIGENTES_VISA,
    GET_COMBO_MONEDAS_VISA,
    GET_COBERTURA_POLIZA_VISA,
    GET_PROVISIONES_IMPLICADOS_VISA,
    GET_HISTORIAL_PROVISIONES_IMPLICADO_VISA,
    GET_COMBO_RESPONSABILIDAD_ASEGURADO,
    GET_AMPAROS_CIA,
    GET_RESERVA_CIA,
    GET_COMBO_DECISION_CIA
} from '../types';


export default function visarProvisionReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM44:
            return { ...state, cfg_form44: action.payload }
        case GET_DATOS_GESTION_IMPLICADO_VISA:
            return { ...state, datosGestionImplicado: action.payload }
        case GET_COMBO_INSTANCIAS_PROVISIONES_VISA:
            return { ...state, comboInstanciasProvisiones: action.payload }
        case GET_PROVISIONES_VIGENTES_VISA:
            return { ...state, listaProvisionesVigentes: action.payload }
        case GET_COMBO_MONEDAS_VISA:
            return { ...state, comboMonedas: action.payload }
        case GET_COBERTURA_POLIZA_VISA:
            return { ...state, listaCoberturaPoliza: action.payload }
        case GET_PROVISIONES_IMPLICADOS_VISA:
            return { ...state, listaProvisionesImplicados: action.payload }
        case GET_HISTORIAL_PROVISIONES_IMPLICADO_VISA:
            return { ...state, listaHistorialProvisionesImplicado: action.payload }
        case GET_COMBO_RESPONSABILIDAD_ASEGURADO:
            return { ...state, comboResponsabilidadAsegurado: action.payload }
        case GET_AMPAROS_CIA:
            return { ...state, amparosCia: action.payload }  
        case GET_RESERVA_CIA:
            return { ...state, reservaCia: action.payload }  
        case GET_COMBO_DECISION_CIA:
            return { ...state, comboDecision: action.payload }  
        default:
            return state
    }
}